export default {
  // Give this a Date object as returned from the date picker object and a time zone,
  // and it returns it as the calendar day as appropriate for the given time zone
  // this function works with momentjs objects only
  serverMomentToMomentInTz: function (moment, jstz, date) {
    let time_zone = jstz.determine().name();
    return moment.tz(date.format("YYYY-MM-DD HH:mm"), time_zone);
  },

  //In the timezone chosen, at the beginning of the day displayed in the date picker, return the time in UTC.
  //this function works with javascript Date objects.
  serverDateToDateInTz: function (moment, jstz, serverDate) {
    //don't use endOf('day') because javascript timestamps are higher-resolution than the database timestamps.
    //so your date object will get rounded up to the start of the next day when stored
    return this.serverMomentToMomentInTz(moment, jstz, moment(serverDate)).toDate();
  },

  serverDateToMomentInTz: function (moment, jstz, serverDate) {
    return this.serverMomentToMomentInTz(moment, jstz, moment(serverDate));
  },

  uuidv4: () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  },

  cloneObject: obj => {
    return JSON.parse(JSON.stringify(obj));
  },

  humanizeAccessCode: function (s) {
    return s.substring(0, 3) + '-' + s.substring(3, 6) + '-' + s.substring(6, 9);
  },

  // convert string to boolean
  // if obj is already a boolean, it is returned as is
  // if obj is null, the default_value is returned
  asBoolean: (obj, default_value) => {
    if (obj == null) {
      return default_value === undefined ? false : default_value;
    } else if (typeof obj === "string") {
      return obj.toLowerCase() == 'true';
    } else {
      return obj;
    }
  },

  // find an item in a list of objects by checking a specified item property with a specified search value
  findListItem: (list, search_property, search_value, on_success, on_failure) => {
    let index = list.findIndex(item => {
      return item[search_property] === search_value;
    });
    if (index === -1) {
      if (on_success == null) {
        //console.log('Could not find item with property ' + search_property + '=' + search_value + ' in list')
        return null;
      }
      return on_failure == null ? null : on_failure();
    } else {
      return on_success == null ? list[index] : on_success(list[index], index);
    }
  },

  rgbToHex: rgb => {
    var a = rgb.split("(")[1].split(")")[0];
    a = a.split(",");
    var b = a.map(function (x) {
      //For each array element
      x = parseInt(x).toString(16); //Convert to a base16 string
      return x.length == 1 ? "0" + x : x; //Add zero if we get only one character
    });
    return "#" + b.join("");
  },

  hexToRgb(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  },

  validateHexColorString: hex => {
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    return hex;
  },

  getLuminance: function (hex) {
    hex = this.validateHexColorString(hex);

    // convert to decimal and change luminosity
    let r = parseInt(hex.substr(0, 2), 16);
    let g = parseInt(hex.substr(2, 2), 16);
    let b = parseInt(hex.substr(4, 2), 16);

    return 0.299 * r + 0.587 * g + 0.114 * b;
  },

  // calculate difference between two colors (0 = same color, 255 = totally different)
  // homebrew algorithm, now scientifically correct
  getColorDiffIndex: function (hex1, hex2) {
    hex1 = this.validateHexColorString(hex1);
    hex2 = this.validateHexColorString(hex2);

    // convert to decimal
    let rdiff = Math.abs(parseInt(hex2.substr(0, 2), 16) - parseInt(hex1.substr(0, 2), 16));
    let gdiff = Math.abs(parseInt(hex2.substr(2, 2), 16) - parseInt(hex1.substr(2, 2), 16));
    let bdiff = Math.abs(parseInt(hex2.substr(4, 2), 16) - parseInt(hex1.substr(4, 2), 16));

    return 0.299 * rdiff + 0.587 * gdiff + 0.114 * bdiff;
  },

  // lighten or darken a hex color
  shadeColor(hex, lum) {
    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#",
        c,
        i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      if (lum < 0) {
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      } else {
        c = Math.round(Math.min(Math.max(0, c + (255 - c) * lum), 255)).toString(16);
      }
      rgb += ("00" + c).substr(c.length);
    }

    return rgb;
  },

  // get parameter from the hash string or from the actual query
  // this way parameters both before and after the hash sign is supported
  getHashOrQueryParameter(component, name) {
    if (component.$route.query[name]) {
      return component.$route.query[name];
    }
    return this.getQueryParameterByName(name);
  },

  getQueryParameterByName: function (name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  },

  removeQueryParameters() {
    var url = window.location.href.split("?")[0];
    var hash_url = window.location.href.split("#");
    if (hash_url.length > 1) {
      url += "#" + hash_url[1];
    }
    window.history.pushState({}, document.title, url);
  },

  originOfURL: function (url) {
    var path_array = url.split('/');
    var protocol = path_array[0];
    var host = path_array[2];
    var url = protocol + '//' + host;
    return url;
  }

};


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/utils.js
// module id = pmn+
// module chunks = 1 2 3 4 5 6